// components/LazyEntitySelect.jsx
import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import useAsyncCursorLoader from "./AsyncSelectHook";
import { colors } from "../../theme/colors";
import Text from "../typography/text";

export default function LazyEntitySelect({
  // generic props
  value,
  onChange,
  placeholder = "Search...",
  isMulti = true,
  // loader config
  apiPath = "/GetReportFilterOptions",
  pageSize = 25,
  staticParams,     // e.g., { type: 'accounts' }
  mapItem,          // optional mapper if keys differ
  // UI tweaks
  menuZIndex = 9999,
  getOptionValueFn,
}) {
  const loadOptions = useAsyncCursorLoader({ apiPath, pageSize, staticParams, mapItem });

  return (
    <div>
      <AsyncPaginate
        isMulti={isMulti}
        value={value}
        onChange={onChange}
        loadOptions={loadOptions}
        debounceTimeout={250}
        placeholder={placeholder}
        defaultOptions
        loadOptionsOnMenuOpen
        additional={null}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        getOptionValue={(opt) =>
          typeof getOptionValueFn === "function" ? getOptionValueFn(opt) : String(opt.value)
        }
        getOptionLabel={(opt) => String(opt.label)}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? "No matches" : "Type to search or open menu"
        }
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: menuZIndex }),
          placeholder: (base) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
            fontSize: "14px",
            color: colors["lightText"],
          }),
          input: (base) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
          }),
          option: (base, state) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
            fontSize: "14px",
            color: state.isFocused ? colors["white"] : colors["darkText"],
            backgroundColor: state.isFocused
              ? colors["primaryColor"]
              : colors["white"],
            borderRadius: "4px",
            paddingTop: "8px",
            paddingBottom: "8px",
            cursor: "pointer",
          }),
        }}
      />
    </div>
  );
}
